import { AllowedUsers } from '../components/AllowedUsers/AllowedUsers';

export const BotAllowedUsersPage = () => {
  return <AllowedUsers />;
};
